<template>
  <footer class="footer--global">
    <keep-alive>
      <div class="footer__top">
        <div class="section__container">
          <v-row class="footer__top-row">
            <v-col
              lg="4"
              md="12"
              sm="12"
              class="section__col footer__top-section logo-section ps-0"
            >
              <v-img
                class="logo"
                eager
                :src="require('@/assets/img/Digu_Logo_White.webp')"
                :width="110"
              ></v-img>
              <p class="description m400">Driving Innovation and Growth Unlimited</p>

              <!-- Contact Section -->
              <div class="contact-section">
                <p class="contact-text">
                  Have a question or want to reach out?
                  <a href="mailto:info@digu.one" class="contact-link"
                    >email us</a
                  >,
                  <a @click="redirectToCalendly" class="contact-link"
                    >schedule a meeting</a
                  >, or call us at
                  <a href="tel:+18335963361" class="contact-link"
                    >+1 (833) 596 3361</a
                  >.
                </p>
                <v-btn class="contact-btn" href="/contact" outlined>
                  Contact Us
                </v-btn>
              </div>
            </v-col>

            <v-col
              lg="6"
              md="12"
              sm="12"
              cols="12"
              class="footer__top-section top-right-section"
            >
              <v-row class="section__row">
                <v-col class="section__col">
                  <ol class="footer__section-list">
                    <li class="footer__section-link">
                      <a class="m500" href="/about">About Us</a>
                    </li>
                    <!-- Replaced by Services in security mode.
                    <li class="footer__section-link">
                      <a class="m500" href="/design-my-app">Our Solutions</a>
                    </li> -->
                    <li class="footer__section-link">
                      <a class="m500" :href="ROUTES.services">Services</a>
                    </li>

                    <li class="footer__section-link">
                      <a class="m500" href="/blogs-and-insights"
                        >Blogs and Insights</a
                      >
                    </li>
                    <li class="footer__section-link">
                      <a class="m500" href="/grassroot-impact-initative"
                        >Grassroot Impact Initiative</a
                      >
                    </li>
                  </ol>
                </v-col>
                <v-col class="section__col">
                  <ol class="footer__section-list">
                    <!-- Replaced by Maturity Roadmap in security mode.
                    <li class="footer__section-link">
                      <a class="m500" href="/customers">Customer Stories</a>
                    </li> -->
                    <li class="footer__section-link">
                      <a class="m500" :href="ROUTES.roadmap">Maturity Roadmap</a>
                    </li>
                    <!-- <li class="footer__section-link">
                      <a class="m500" href="/grassroot-impact-initative"
                        >DIGU Cares</a
                      >
                    </li> -->
                    <li class="footer__section-link">
                      <a class="m500" href="/impact-stories">Impact Stories</a>
                    </li>
                    <li class="footer__section-link">
                      <a class="m500" href="/customers">Customer Stories</a>
                    </li>
                    <li class="footer__section-link">
                      <a class="m500" href="/talents-on-demand"
                        >Join Our Talent Pool</a
                      >
                    </li>
                  </ol>
                </v-col>
              </v-row>
            </v-col>

            <v-col
              lg="2"
              md="12"
              sm="12"
              cols="12"
              class="footer__top-section follow-section"
            >
              <p class="hq-address">
                <span class="bold">Follow Us</span><br />
              </p>
              <keep-alive>
                <div class="social-links">
                  <a
                    href="https://www.linkedin.com/company/digu-official/"
                    target="_blank"
                    class="social-link"
                  >
                    <v-img
                      :src="require('@/assets/img/linkedin.svg')"
                      eager
                      width="20"
                      height="20"
                    ></v-img>
                  </a>
                  <a
                    href="https://www.instagram.com/digu.official/"
                    target="_blank"
                    class="social-link"
                  >
                    <v-img
                      :src="require('@/assets/img/instagram.svg')"
                      eager
                      width="20"
                      height="20"
                    ></v-img>
                  </a>
                  <a
                    href="https://www.tiktok.com/@digu.official"
                    target="_blank"
                    class="social-link"
                  >
                    <v-img
                      :src="require('@/assets/img/tiktok.svg')"
                      eager
                      width="20"
                      height="20"
                    ></v-img>
                  </a>
                  <a
                    href="https://www.facebook.com/digu.official/"
                    target="_blank"
                    class="social-link"
                  >
                    <v-img
                      :src="require('@/assets/img/facebook.svg')"
                      eager
                      width="20"
                      height="20"
                    ></v-img>
                  </a>
                  <a
                    href="https://x.com/digu_official"
                    target="_blank"
                    class="social-link"
                  >
                    <v-img
                      :src="require('@/assets/img/x-twitter.svg')"
                      eager
                      width="20"
                      height="20"
                    ></v-img>
                  </a>
                  <a
                    href="https://www.youtube.com/@digu_official"
                    target="_blank"
                    class="social-link"
                  >
                    <v-img
                      :src="require('@/assets/img/youtube.svg')"
                      eager
                      width="15"
                      height="15"
                    ></v-img>
                  </a>
                </div>
              </keep-alive>
            </v-col>
          </v-row>
        </div>
      </div>
    </keep-alive>

    <div class="footer__bottom pa-10">
      <div class="section__container">
        <v-row class="footer__bottom-row">
          <v-col cols="12" sm="6" class="pa-0 footer__bottom-col">
            <p class="footer__copyright m500">
              &copy; 2023 - {{ getCurrentYear }} DIGU &#124; All Rights Reserved
            </p>
          </v-col>
          <v-col
            cols="12"
            sm="6"
            class="pa-0 footer__bottom-col d-sm-flex justify-end"
          >
            <a href="/privacy-policy" class="privacy-link">Privacy Policy</a>
          </v-col>
        </v-row>
      </div>
    </div>
  </footer>
</template>

<script>
// Security-mode copy of partials/GlobalFooter.vue: same markup and styles, with
// Our Solutions -> Services and Customer Stories -> Maturity Roadmap.
// The legacy footer is untouched; App.vue picks one by SITE_MODE.
import '@/assets/css/security-theme.css';
import { ROUTES } from '@/content/security/routes';

export default {
  name: 'SecurityGlobalFooter',
  data: () => ({
    ROUTES,
  }),
  computed: {
    getCurrentYear() {
      return new Date().getFullYear();
    },
  },
  methods: {
    // Redirect to Calendly
    redirectToCalendly() {
      window.open(
        process.env.VUE_APP_CALENDLY_LINK, // Use the env variable here
        '_blank'
      );
    },
  },
};
</script>

<style scoped>
.footer--global {
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.footer__top {
  width: 100vw;
  display: flex;
  background-color: var(--dark-2);
  padding-block: 3rem;
}

@media only screen and (min-width: 1280px) {
  .footer__top {
    padding-inline: 0px;
  }
}

.footer__top-row {
  max-width: 1400px;
  margin-inline: auto;
}

@media only screen and (min-width: 2000px) {
  .footer__top-row {
    max-width: 1920px;
  }
}

/* Logo Section */
.logo-section {
  padding-inline: 0px;
}

@media only screen and (min-width: 1366px) {
  .logo-section {
    background-image: url('@/assets/img/map.svg');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
  }
}

.logo {
  color: var(--light-1);
  margin-bottom: 0.5rem;
}

.description {
  color: var(--light-1);
  font-size: 1rem;
  margin-bottom: 2rem;
}

@media only screen and (min-width: 1280px) {
  .description {
    width: 24rem;
  }
}

/* Contact Section */
.contact-section {
  margin-top: 1.5rem;
}

.contact-text {
  color: var(--light-1);
  font-size: 0.95rem;
  line-height: 1.5;
  margin-bottom: 1.5rem;
}

.contact-link {
  color: var(--sec-accent);
  text-decoration: none;
  transition: color 0.3s ease;
  cursor: pointer;
}

.contact-link:hover {
  text-decoration: underline;
}

.contact-btn {
  border: 1px solid var(--sec-on-accent);
  color: var(--sec-on-accent);
  background-color: transparent;
  padding: 0.75rem 1.5rem;
  border-radius: 4px;
  text-transform: none;
  height: 45px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
}

.contact-btn:hover {
  background-color: var(--sec-on-accent);
  color: var(--dark-2);
}

/* Navigation Sections */
.footer__top-section {
  text-align: left;
  padding-inline: 0px;
}

.top-right-section {
  display: flex;
  flex-wrap: wrap;
}

@media only screen and (min-width: 1200px) {
  .footer__top-section {
    padding-inline: 1rem;
  }
}

.footer__section-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

.footer__section-link {
  margin-bottom: 0.75rem;
  text-decoration: none;
  min-width: 150px;
  line-height: normal;
  margin-bottom: 1.5rem;
}

.footer__section-link:last-child {
  margin-bottom: 0px;
}

.footer__section-link > a {
  text-decoration: none;
  color: var(--light-1);
  transition: color 0.3s ease;
}

.footer__section-link > a:hover {
  text-decoration: none;
  color: var(--secondary-color);
}

/* Follow Section */
.follow-section {
  display: flex;
  flex-direction: column;
  max-width: 180px;
}

.hq-address {
  color: var(--light-1);
  margin-bottom: 1rem;
}

.social-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  /* max-width: 180px; */
  gap: 0.75rem;
}

.social-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 35px;
  height: 35px;
  border-radius: 50%;
  transition: all 0.3s ease;
  background-color: var(--sec-footer-social-bg);
}

.social-link:hover {
  background-color: var(--sec-footer-social-bg-hover);
  transform: translateY(-2px);
}

/* Footer Bottom */
.footer__bottom {
  width: 100vw;
  display: flex;
  background-color: var(--dark-4);
  padding: 2rem;
}

.footer__bottom-col {
  padding: 0px;
  font-size: 0.85rem;
}

@media only screen and (min-width: 900px) {
  .footer__bottom-col {
    font-size: 0.95rem;
  }
}

.footer__copyright {
  max-width: 1400px;
  margin-inline: auto;
  text-align: left;
  color: var(--light-1);
}

.privacy-link {
  color: var(--light-1);
  text-decoration: none;
  transition: color 0.3s ease;
}

.privacy-link:hover {
  color: var(--secondary-color);
}

@media only screen and (min-width: 1280px) {
  .footer__copyright {
    text-align: left;
  }
}
@media only screen and (max-width: 1280px) {
  .follow-section {
    display: flex;
    flex-direction: column;
    max-width: 1000px;
  }
}

@media only screen and (min-width: 2000px) {
  .footer__copyright {
    max-width: 1920px;
  }
}

/* Mobile Responsive Styles */
@media only screen and (max-width: 768px) {
  .footer__top {
    padding-block: 2rem;
  }

  .footer__top-row {
    flex-direction: column;
  }

  .footer__top-section {
    margin-bottom: 2rem;
    text-align: left;
  }

  .footer__top-section:last-child {
    margin-bottom: 0;
  }

  .logo-section {
    background-image: none;
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: left;
    align-content: left;
  }

  .description {
    width: 100%;
    text-align: left;
  }

  .contact-text {
    text-align: left;
  }

  .top-right-section .section__row {
    justify-content: left;
  }

  .footer__section-list {
    text-align: left;
  }

  .social-links {
    justify-content: left;
    max-width: 100%;
  }

  .footer__bottom {
    padding: 3rem;
  }

  .footer__bottom-col {
    text-align: left;
    margin-bottom: 10px;
  }
  .footer__copyright {
    text-align: left;
  }

  .footer__bottom-col:last-child {
    /* margin-top: 1rem; */
  }
}

@media only screen and (max-width: 480px) {
  .contact-text {
    font-size: 0.85rem;
  }

  .contact-btn {
    /* width: 100%; */
    margin-top: 0.5rem;
  }

  .social-links {
    gap: 0.5rem;
  }

  .social-link {
    width: 35px;
    height: 35px;
  }
}

/* Tablet Responsive Styles */
@media only screen and (min-width: 769px) and (max-width: 1199px) {
  .footer__top-section {
    margin-bottom: 2rem;
  }

  .follow-section {
    text-align: left;
  }

  .social-links {
    justify-content: left;
  }
  .follow-section {
    display: flex;
    flex-direction: column;
    max-width: 280px;
  }
}

/* Large Desktop Styles */
@media only screen and (min-width: 1200px) {
  .footer__top-section {
    margin-bottom: 0;
  }

  .follow-section {
    text-align: left;
  }

  .social-links {
    justify-content: flex-start;
  }
}
</style>
